export class texture360
{
    public constructor() {
    }
    public my_w=2048*8;//   4096;//8192;
    public my_h=2048;
    public off=0;
    public static async gentexture(scene:BABYLON.Scene,left:Uint8ClampedArray,right:Uint8ClampedArray,top:Uint8ClampedArray,bot:Uint8ClampedArray,front:Uint8ClampedArray,back:Uint8ClampedArray,my_w:number,my_h:number,off:number):Promise<BABYLON.DynamicTexture>
    {
        //创建一张动态贴图并把它二进制化
        let texture = new BABYLON.DynamicTexture("dynamic texture", {width:my_w,height:my_h}, scene, true);
		var pixeldata = await texture.readPixels();
		if(pixeldata==null)
			return texture;
        var arr = new Uint8ClampedArray(pixeldata.buffer);

        let cubeFaceWidth = 2048;// sourceTexture.width / 4; // 4个水平面
        let cubeFaceHeight = 2048;// sourceTexture.height / 3; // 3个垂直面
        

        let single_l=2048+4;

        for(let j = 0; j< my_h; j ++)
        {
            let xPixel=0;
			let yPixel=0;
            for(let i = 0; i< my_w; i ++)
            {
                if(i<single_l&&j<2048)
                {
                    xPixel=i-2;
                    yPixel=j;

                    if(xPixel<=0)
                        xPixel=0;

                    if(xPixel>=2048)
                        xPixel=2047;

                    arr[my_w*j*4+i*4]=left[cubeFaceHeight*yPixel*4+xPixel*4]+off;//right
					arr[my_w*j*4+i*4+1]=left[cubeFaceHeight*yPixel*4+xPixel*4+1]+off;
					arr[my_w*j*4+i*4+2]=left[cubeFaceHeight*yPixel*4+xPixel*4+2]+off;
                    arr[my_w*j*4+i*4+3]=left[cubeFaceHeight*yPixel*4+xPixel*4+3];
                }
                else if(i<single_l*2&&j<2048) //if(i<2048*2&&j<2048)
                {
                    xPixel=i-single_l-2;
                    yPixel=j;
                    if(xPixel<=0)
                    xPixel=0;

            

                    if(xPixel>=2048)
                        xPixel=2047;
                    
                    arr[my_w*j*4+i*4]=right[cubeFaceHeight*yPixel*4+xPixel*4]+off;//right
					arr[my_w*j*4+i*4+1]=right[cubeFaceHeight*yPixel*4+xPixel*4+1]+off;
					arr[my_w*j*4+i*4+2]=right[cubeFaceHeight*yPixel*4+xPixel*4+2]+off;
                    arr[my_w*j*4+i*4+3]=right[cubeFaceHeight*yPixel*4+xPixel*4+3];

                }
                else if(i<single_l*3&&j<2048)
                {
                    xPixel=i-single_l*2-2;
                    yPixel=j;
                    if(xPixel<=0)
                    xPixel=0;
                    if(xPixel>=2048)
                        xPixel=2047;

                    arr[my_w*j*4+i*4]=front[cubeFaceHeight*yPixel*4+xPixel*4]+off;//right
					arr[my_w*j*4+i*4+1]=front[cubeFaceHeight*yPixel*4+xPixel*4+1]+off;
					arr[my_w*j*4+i*4+2]=front[cubeFaceHeight*yPixel*4+xPixel*4+2]+off;
                    arr[my_w*j*4+i*4+3]=front[cubeFaceHeight*yPixel*4+xPixel*4+3];

                }
                else if(i<single_l*4&&j<2048)
                {
                    xPixel=i-single_l*3-2;
                    yPixel=j;
                    if(xPixel<=0)
                    xPixel=0;
                    if(xPixel>=2048)
                        xPixel=2047;

                    arr[my_w*j*4+i*4]=back[cubeFaceHeight*yPixel*4+xPixel*4]+off;//right
					arr[my_w*j*4+i*4+1]=back[cubeFaceHeight*yPixel*4+xPixel*4+1]+off;
					arr[my_w*j*4+i*4+2]=back[cubeFaceHeight*yPixel*4+xPixel*4+2]+off;
                    arr[my_w*j*4+i*4+3]=back[cubeFaceHeight*yPixel*4+xPixel*4+3];
                }
                else if(i<single_l*5&&j<2048)
                {
                    xPixel=i-single_l*4-2;
                    yPixel=j;

                    if(xPixel<=0)
                    xPixel=0;
                    
                    if(xPixel>=2048)
                        xPixel=2047;
                    arr[my_w*j*4+i*4]=top[cubeFaceHeight*yPixel*4+xPixel*4]+off;//right
					arr[my_w*j*4+i*4+1]=top[cubeFaceHeight*yPixel*4+xPixel*4+1]+off;
					arr[my_w*j*4+i*4+2]=top[cubeFaceHeight*yPixel*4+xPixel*4+2]+off;
                    arr[my_w*j*4+i*4+3]=top[cubeFaceHeight*yPixel*4+xPixel*4+3];

                }
                else if(i<single_l*6&&j<2048)
                {
                    xPixel=i-single_l*5-2;
                    yPixel=j;

                    if(xPixel<=0)
                    xPixel=0;

                    if(xPixel>=2048)
                        xPixel=2047;

                    arr[my_w*j*4+i*4]=bot[cubeFaceHeight*yPixel*4+xPixel*4]+off;//right
					arr[my_w*j*4+i*4+1]=bot[cubeFaceHeight*yPixel*4+xPixel*4+1]+off;
					arr[my_w*j*4+i*4+2]=bot[cubeFaceHeight*yPixel*4+xPixel*4+2]+off;
					arr[my_w*j*4+i*4+3]=bot[cubeFaceHeight*yPixel*4+xPixel*4+3];
                }
                else
                {

                }
            }

        }

        var textureContext = texture.getContext();
		var imageData = new ImageData(arr,my_w, my_h);
		textureContext.putImageData(imageData, 0, 0);
        texture.update();
        return texture;
    }


}